import { gsap } from 'gsap';

function productPageSetup(el) {
  const { children: infos } = el.querySelector('.product-info');
  const { children: images } = el.querySelector('.product-gallery');

  if (infos) gsap.set(infos, { autoAlpha: 0, y: 30 })
  if (images) {
    [...images].forEach(item => {
      const img = item.querySelector('img');
      gsap.set(item, { autoAlpha: 0 })
      gsap.set(img, { scale: 1.2 })
    });
  }
}

function productPageEnter(el) {
  const { children: infos } = el.querySelector('.product-info');
  const { children: images } = el.querySelector('.product-gallery');


  const tl = gsap.timeline({ defaults: { duration: 1, ease: 'power2.out' } });
  if (infos) tl.to(infos, { autoAlpha: 1, y: 0, stagger: 0.08 }, 0);

  if (images) {
    [...images].forEach((item, i) => {
      const img = item.querySelector('img');
      tl.to(item, { autoAlpha: 1 }, 0.1 * i);
      tl.to(img, { scale: 1 }, 0.1 * i);
    });
  }
}

export { productPageSetup, productPageEnter };